import { render } from "./pay-agree.vue?vue&type=template&id=278a1e22"
import script from "./pay-agree.vue?vue&type=script&lang=js"
export * from "./pay-agree.vue?vue&type=script&lang=js"

import "./pay.less?vue&type=style&index=0&lang=less"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__